import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import contactActions from 'actions/contacts/actions'
import { FORM_SECTIONS } from 'constants/user-venues'

const ContactList = ({
  fetchContacts,
  list,
  setAction,
  venueId,
  handleSetSuccess,
  setContact,
  name,
}) => {
  useEffect(() => {
    if (venueId) {
      fetchContacts({ id: venueId })
    }
  }, [])
  useEffect(() => {
    if (list.length) {
      handleSetSuccess({ [FORM_SECTIONS.CONTACTS]: true })
    }
  }, [list])

  const contactClick = (action, contact) => {
    setContact(contact)
    setAction(action)
  }

  const NewContact = () => (
    <div className="contact w-1/3 p-5">
      <div
        className="contact-details m-2 p-2 rounded-lg border border-gray-300 cursor-pointer"
        onClick={() => contactClick('add', null)}
      >
        <div className="px-2 mr-1">
          <div className="w-full h-14 text-center">
            <i className="fa fa-plus text-gray-500 text-3xl" aria-hidden="true"></i>
            <p className="text-gray-500">Add New Contact</p>
          </div>
        </div>
      </div>
    </div>
  )

  const renderContactList = () => (
    <div className="contact-list flex flex-wrap">
      <NewContact />
      {list.map((contact) => (
        <div className="contact w-1/3 p-5" key={contact.id}>
          <div
            className="contact-details m-2 p-2 rounded-lg flex border border-gray-300 cursor-pointer"
            onClick={() => contactClick('edit', contact)}
          >
            <div className="contact-avatar px-2 mr-1">
              <img
                src={contact.image_filename || require('assets/images/default-profile.png')}
                className="rounded-full object-cover w-14 h-14"
              />
            </div>
            <div className="contant-name my-auto">
              <p className="">{contact.name}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <div className="venue-contact">
      <div className="pb-10">
        <h5 className="font-bold">{name}</h5>
      </div>
      {renderContactList()}
    </div>
  )
}

ContactList.propTypes = {
  fetchContacts: PropTypes.func,
  list: PropTypes.array,
  setAction: PropTypes.func,
  venueId: PropTypes.number,
  handleSetSuccess: PropTypes.func,
  setContact: PropTypes.func,
  name: PropTypes.string,
}

const mapStateToProps = ({ contacts, venue }) => ({
  list: contacts.list || [],
  name: venue.details.name,
})

const mapDispatchToProps = {
  fetchContacts: contactActions.fetchContacts,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactList)
